import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import getLabels from '../../utils/getLabels'

import Icon from '../Icon'

class Notifications extends Component {
  state = {}

  static getDerivedStateFromProps(nextProps) {
    if (
      nextProps.type === 'success' &&
      nextProps.notifications.length &&
      nextProps.removeNotification
    ) {
      setTimeout(() => {
        for (const notification of nextProps.notifications) {
          nextProps.removeNotification(notification)
        }
      }, 5000)
    }

    return nextProps
  }

  render() {
    const { notifications, classes, clearNotifications, type } = this.props

    if (!notifications.length) {
      return false
    }

    const isSuccessNotification = type === 'success'

    const notificationMessages = []
    const filteredNotifications = notifications
      .map(notification => ({
        ...notification,
        message: getLabels(notification.message),
      }))
      .filter(notification => notification.message)
      .filter(notification => {
        if (!notificationMessages.includes(notification.message)) {
          notificationMessages.push(notification.message)
          return notification
        }
        return false
      })

    return (
      <div
        className={classnames(classes.notification, {
          [classes.success]: isSuccessNotification,
          [classes.error]: !isSuccessNotification,
        })}
        data-element={
          isSuccessNotification ? 'notifications' : 'error-messages'
        }
      >
        <div>
          {filteredNotifications.map((notification, i) => (
            <p
              key={i}
              data-element={
                isSuccessNotification ? 'notification' : 'error-message'
              }
            >
              {getLabels(notification.message)}
            </p>
          ))}
        </div>
        <Icon
          name="close"
          className={classes.removeNotificationIcon}
          onClick={clearNotifications}
        />
      </div>
    )
  }
}

Notifications.defaultProps = {
  notifications: [],
  type: 'error',
}

Notifications.propTypes = {
  classes: PropTypes.shape({
    removeNotification: PropTypes.string,
  }),
  clearNotifications: PropTypes.func.isRequired,
  notifications: PropTypes.array,
  removeNotification: PropTypes.func,
  type: PropTypes.string,
}

export default Notifications
